import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from 'utils/connectFC';

import { PromotionsListFC, PromotionsListFCProps } from './PromotionsListFC';

const useStrings = (): PromotionsListFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      buttons: {
        continue: intl.formatMessage({ id: 'buttons.continue' }),
        back: intl.formatMessage({ id: 'buttons.back' }),
      },
      title: intl.formatMessage({ id: 'components.PromotionsList.title' }),
    }),
    [intl],
  );
};

type PromotionsListProps = Omit<PromotionsListFCProps, 'strings'>;

export const PromotionsList = connectFC(PromotionsListFC, (props: PromotionsListProps) => {
  const strings = useStrings();

  return { ...props, strings };
});
